import hyperdom from 'hyperdom'
import BasePaymentMethod from './basePaymentMethod.jsx'

export default class Uplift extends BasePaymentMethod {
  constructor (payment) {
    super(payment)
    this.booking = payment.booking
    payment.renderProceedWithBooking = false
  }

  eligible () {
    return this.booking.booking.paymentMethods.creditCard && this.payment.config.upliftApiKey && this.payment.config.upliftCode
  }

  failed () {
    this.payment.uplift.orderError('Error processing payment')
    const errors = [{message:'Sorry, an error occurred while processing payment. Your credit agreement has been cancelled. Please select another payment method'}]
    this.payment.serverErrorsPanel.setErrors(errors)
    this.hasFailed = true
  }

  success () {
    this.booking.paidViaUplift = true
    this.payment.uplift.orderConfirmation(this.payment.booking.booking.bookingReference)
  }

  renderTermsAndConditions () {
    if(!this.hasFailed && this.payment.renderProceedWithBooking){
      return this.payment.renderTermsAndConditions()
    }
  }

  renderPaymentSummary () {
    if(!this.hasFailed && this.payment.renderProceedWithBooking){
      return <button type='submit' class='btn-primary pay-now-btn'>Continue</button>
    }
  }

  book () {
    this.payment.showLoading()
    this.payment.uplift.processPayment()
  }

  render () {
    if (this.hasFailed) {
      return
    }
    const {selected:paymentOption} = this.payment.paymentOptions
    return (
      <span style={paymentOption.isMonthly && !this.payment.upliftRejected ? '' : 'display:none'}>
        {this.payment.uplift}
        {this.payment.renderPaymentMethodSelection({noDetails: false})}
        {this.renderTermsAndConditions()}
      </span>
    )
  }
}
